import {gql} from 'apollo-angular';
import {StatusFragment} from "../../fragments/Status";

export const SEND_CLICK_THE_PIC_ANSWER = gql`
  query SendClickThePicAnswer($gameId: Int!, $questionId: Int!, $answerId: Int!, $points: Int!) {
    sendClickThePicAnswer(gameID: $gameId, questionID: $questionId, answerID: $answerId, points: $points) {
        status {
          ...statusFields
        }
        correctAnswerId
    }
  }
  ${StatusFragment}
`;

